// packages/shared-components/src/components/Iconfont/Iconfont.tsx
import { forwardRef, useEffect } from "react";
import { IconfontProps } from "./types";

declare const __APP_BUILD_VERSION__: string | undefined;

const getIconfontStylesheetVersion = (): string => {
  if (typeof window !== "undefined") {
    const globalVersion = (
      window as Window & { __APP_BUILD_VERSION__?: string }
    ).__APP_BUILD_VERSION__;
    if (globalVersion) return globalVersion;
  }
  if (typeof __APP_BUILD_VERSION__ !== "undefined") {
    return __APP_BUILD_VERSION__;
  }
  return "";
};

function isIconfontStylesheetPresent() {
  if (document.getElementById(ICONFONT_STYLESHEET_ID)) {
    return true;
  }
  return Boolean(
    document.querySelector(`link[rel="stylesheet"][href*="iconfont.css"]`)
  );
}

export const Iconfont = forwardRef<HTMLElement, IconfontProps>(
  ({ icon = "", className = "", children, ...props }, ref) => {
    useEffect(() => {
      const linkId = "sub-app-iconfont";
      const version = getIconfontStylesheetVersion();
      const href = version
        ? `/iconfont/iconfont.css?v=${encodeURIComponent(version)}`
        : "/iconfont/iconfont.css";
      const existing = document.getElementById(
        linkId
      ) as HTMLLinkElement | null;
      if (existing) {
        if (existing.href !== new URL(href, window.location.origin).href) {
          existing.href = href;
        }
        return;
      }
      const link = document.createElement("link");
      link.id = linkId;
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
    }, []);
    return (
      <i
        ref={ref as any}
        className={`iconfont icon-${icon} ${className}`}
        {...props}
      />
    );
  }
);

Iconfont.displayName = "Iconfont";
